import { animate, stagger } from 'motion'
import ease from '@/utils/ease'

export default () => ({
	init() {
		this.setupEventListeners()
		this.menuToggle = document.querySelector('[data-menu-toggle]')
	},

	setupEventListeners() {
		window.addEventListener('mobile-menu:open', () => {
			this.openMenu()
		})

		window.addEventListener('mobile-menu:close', () => {
			this.closeMenu()
		})
	},

	openMenu() {
		const menu = this.$el
		const variants = this.$el.querySelectorAll('[data-animate-variant]')

		if (!variants) return

		animate(menu, { transform: 'translateX(0)' }, { duration: 0.3, easing: ease.outQuint })

		setTimeout(() => {
			animate(
				variants,
				{ opacity: 1 },
				{ duration: 0.25, delay: stagger(0.05), easing: ease.outQuint },
			)
		}, 100)
	},

	closeMenu() {
		const menu = this.$el
		const variants = Array.from(this.$el.querySelectorAll('[data-animate-variant]'))

		if (!variants) return

		// Remove focus from any focused elements inside the menu before closing
		const focusedElement = this.$el.querySelector(':focus')
		if (focusedElement) {
			focusedElement.blur()
			if (this.menuToggle) {
				this.menuToggle.focus()
			}
		}

		// Fade out items quickly
		animate(variants, { opacity: 0 }, { duration: 0.15, easing: ease.outCubic })

		// Slide menu out to the left
		setTimeout(() => {
			animate(
				menu,
				{ transform: 'translateX(-100%)' },
				{ duration: 0.3, easing: ease.outQuint },
			)
		}, 50)
	},
})
